import { useEffect, useState } from "react"
import { Header, HeaderContent, HeaderSubheader, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Image, Button, Label } from "semantic-ui-react"


import { CashierService } from "../../services"

import { FeedbackMessage } from "../../constants"


export function CashierDailyReports() 
{

    const [dailyReports, setDailyReports] = useState<any[]>([])
    const [feedbackError, setFeedbackError] = useState<boolean>(false)
    const [feedbackErrorMsg, setFeedbackErrorMsg] = useState<string>('')

    useEffect( () => {
        getMyDailyReports()
    }, [])



    const getMyDailyReports = async() => {

        try {
            const result = await CashierService.getMyDailyReports()

            setDailyReports(result)

            console.log(result)

        } catch (error) {

            setFeedbackError(true)

            setFeedbackErrorMsg(FeedbackMessage.CASHIER_GET_DR_ERROR)
        }
    }


    return  <Table basic='very' celled>
    <TableHeader>
      <TableRow>
        <TableHeaderCell>Numéro</TableHeaderCell>
        <TableHeaderCell>Solde ouverture</TableHeaderCell>
        <TableHeaderCell>Solde clôture</TableHeaderCell>
        <TableHeaderCell>Date ouverture</TableHeaderCell>
        <TableHeaderCell>Date fermeture</TableHeaderCell>
        <TableHeaderCell>Encaissement</TableHeaderCell>
        <TableHeaderCell>Décaissement</TableHeaderCell>
        <TableHeaderCell>Etat</TableHeaderCell>
        <TableHeaderCell>Détais</TableHeaderCell>
      </TableRow>
    </TableHeader>

    <TableBody>

      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nº 12</TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              250.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>
            <Header as='h4' image>
            <HeaderContent>
              328.000
              <HeaderSubheader>Un petit commentaire</HeaderSubheader>
            </HeaderContent>
          </Header>
        </TableCell>
        <TableCell>24 Oct. 2024 08h:22</TableCell>
        <TableCell>24 Oct. 2024 16h:59</TableCell>
        <TableCell>10 000</TableCell>
        <TableCell>5 000</TableCell>
        <TableCell><Label color="orange">OPEN</Label></TableCell>
        <TableCell><Button secondary>Détails</Button></TableCell>
      </TableRow>



     
    </TableBody>
  </Table>
}

// 77 519 52 34